var $ = require('../internals/export');

// `Number.EPSILON` constant
// https://tc39.github.io/ecma262/#sec-number.epsilon
$({
  target: 'Number',
  stat: true
}, {
  EPSILON: Math.pow(2, -52)
});